<template>
  <div class="k-image-cropper">
    <input
      ref="imageInput"
      class="k-image-cropper__image"
      type="file"
      name="image"
      accept="image/png,image/jpeg,image/webp,image/gif"
      @change="setImage"
      v-if="isEditing"
    />

    <popup v-show="imgSrc" @close="dropState">
      <template #body>
        <vue-cropper
          ref="cropper"
          :aspect-ratio="1"
          :view-mode="1"
          :src="imgSrc"
        />
      </template>
      <template #bottom>
        <p role="alert" v-if="saveError">Не удалось сохранить фото. Повторите попытку или закройте окно.</p>
        <button :disabled="saving" class="k-article__buy-button k-image-cropper__cancel k-image-cropper__button" @click="dropState">Закрыть</button>
        <button class="k-article__buy-button k-image-cropper__button" v-if="imgSrc && isEditing" :disabled="saving" @click="cropImage">{{ saving ? "Сохранение…" : "Обрезать" }}</button>
      </template>
    </popup>
  </div>
</template>
<script>
import 'cropperjs/dist/cropper.css';
import VueCropper from 'vue-cropperjs';
import Popup from './ThePopup';
export default {
  data: () => ({
    saving: false,
    saveError: false,
    imgSrc: '',
    cropImg: '',
    fileMeta: undefined
  }),
  props: {
    isEditing: Boolean,
    onSave: Function
  },
  components: {
    Popup,
    VueCropper
  },
  methods: {
    dropState() {
      if (this.saving) return;
      this.saveError = false;
      if (this.$refs.imageInput) this.$refs.imageInput.value = '';
      this.cropImg = '';
      this.imgSrc = '';
      this.fileMeta = undefined;
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
  
      return new Blob([ab], {type: mimeString});
    },
    async cropImage() {
      if (this.saving) return;
      this.saving = true;
      this.saveError = false;
      try {
        const canvas = this.$refs.cropper.getCroppedCanvas();
        if (!canvas || !this.fileMeta) throw new Error('ImageNotReady');
        this.cropImg = canvas.toDataURL();
        const file = this.dataURItoBlob(this.cropImg);
        file.name = this.fileMeta.name;
        const saved = await this.onSave(file);
        this.saving = false;
        if (saved === false) this.saveError = true;
        else this.dropState();
      } catch (error) {
        this.saving = false;
        this.saveError = true;
      }
    },
    setImage(e) {
      const file = e.target.files[0];
      this.fileMeta = file;

      if (!file) return;

      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        console.error('Sorry, FileReader API not supported');

        this.dropState();
        this.onSave(file);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.k-image-cropper {
  &__image {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    z-index: 1;
    overflow: hidden;
    opacity: 0;
  }

  &__cancel {
    background-color: #616161;
  }

  &__button {
    border: 0;
  }
}
</style>
